import HelpIcon from '../../icons/HelpIcon'
import { lightImpactVibrate } from '../../utils/appBridge'

type HelpButtonProps = {
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void
  'aria-label'?: string
  className?: string
}

/** Accessible help/info control — min 24×24 target, button role, named for AT. */
export default function HelpButton({
  onClick,
  'aria-label': ariaLabel = 'Help',
  className = ''
}: HelpButtonProps) {
  return (
    <button
      type='button'
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation()
        lightImpactVibrate()
        onClick(e)
      }}
      className={`inline-flex items-center justify-center min-w-[44px] min-h-[44px] p-0 m-0 border-none bg-transparent cursor-pointer focus:outline-none ${className}`}
    >
      <span aria-hidden='true' className='flex items-center justify-center'>
        <HelpIcon />
      </span>
    </button>
  )
}
